<div class="p-4">
    <div>
        COMPLEMENTOS
    </div>
    <div>
        <div class="row justify-content-start align-items-center barraGestorPagos mb-4 pb-4">
            <label class="lblPagos">Pagos</label>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <!-- <button (click)="addPago()"  class="fuse-mat-button-rounded" mat-flat-button>
                    <mat-icon>library_add</mat-icon>
                </button> -->

                <!-- <button (click)="addPago()" mat-mini-fab color="primary" aria-label="Agregar pago">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button> -->

                <button (click)="addPago()" mat-flat-button color="primary">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button>
            </div>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <!-- <button (click)="removePago()"  class="fuse-mat-button-rounded" mat-flat-button
                [disabled]="removeDisabled">
                    <mat-icon>remove_from_queue</mat-icon>
                </button> -->

                <!-- <button (click)="removePago()" [disabled]="removeDisabled" mat-mini-fab color="warn" aria-label="Eliminar">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button> -->

                <button (click)="removePago()" [disabled]="removeDisabled" mat-flat-button color="warn">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button>
            </div>
        </div>
        <div class="col-sm-12 col-md-10 col-xl-10"></div>
        <br>
        <app-pagos *ngFor="let p of countPagos" [ltsMoneda]="ltsMoneda" [ltsMetodoPago]="ltsMetodoPago"
            [ltsObjetoImpuesto]="ltsObjetoImpuesto" [ltsFormaPago]="ltsFormaPago" [indexPagos]="countPagos.length"
            [pago]="p" [banderaActualizarFactura]="banderaActualizarFactura"
            [dataUpdateComplemento]="dataUpdateComplemento">
        </app-pagos>
        <hr>
        <div class="row justify-content-start align-items-center barraGestorPagos mb-4 pb-4">
            <label class="lblPagos">Pagos</label>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <!-- <button (click)="addPago()"  class="fuse-mat-button-rounded" mat-flat-button>
                    <mat-icon>library_add</mat-icon>
                </button> -->

                <!-- <button (click)="addPago()" mat-mini-fab color="primary" aria-label="Agregar pago">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button> -->

                <button (click)="addPago()" mat-flat-button color="primary">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button>
            </div>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <!-- <button (click)="removePago()"  class="fuse-mat-button-rounded" mat-flat-button
                [disabled]="removeDisabled">
                    <mat-icon>remove_from_queue</mat-icon>
                </button> -->

                <!-- <button (click)="removePago()" [disabled]="removeDisabled" mat-mini-fab color="warn" aria-label="Eliminar">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button> -->

                <button (click)="removePago()" [disabled]="removeDisabled" mat-flat-button color="warn">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button>
            </div>
        </div>
    </div>

</div>